/**
 * Уникальные идентификаторы страниц. Используется для указания предыдущей (referer) страницы при навигации.
 */
export enum PageNames {
    /**
     * Идентификатор страницы продолжения черновика по ссылке
     */
    CONTINUE_DRAFT_PAGE_NAME = 'ContinueDraftPage',

    /**
     * Идентификатор страницы перенаправления в МСИ
     */
    REDIRECT_PAGE_NAME = 'RedirectPage',

    /**
     * Идентификатор страницы ввода сведений о работе
     */
    EMPLOYMENT_PAGE_NAME = 'EmploymentPage',

    /**
     * Идентификатор страницы черновика
     */
    DRAFT_ORDER_PAGE_NAME = 'DraftOrderPage',
}
